import { z } from 'zod'

type Translate = (key: string, options?: Record<string, unknown>) => string

export const REWARD_ITEM_NAME_MAX = 40
export const REWARD_ITEM_DESCRIPTION_MAX = 120

export function rewardItemSchema(t: Translate, i18nPrefix: string) {
  const englishNameRequiredMessage = t(`${i18nPrefix}.modal.nameIncomplete`, {
    language: t(`${i18nPrefix}.modal.langEnglish`),
  })

  return z.object({
    name: z.object({
      en: z.string().min(1, { message: englishNameRequiredMessage }).max(REWARD_ITEM_NAME_MAX),
      sv: z.string().max(REWARD_ITEM_NAME_MAX),
    }),
    description: z.object({
      en: z.string().max(REWARD_ITEM_DESCRIPTION_MAX),
      sv: z.string().max(REWARD_ITEM_DESCRIPTION_MAX),
    }),
    imageUrl: z.string().nullable(),
    active: z.boolean(),
  })
}
